import { WorkflowIndexReduxState } from './types';

import { REDUX_ACTION_TYPES } from './constants';
import {
  handleThumbnailFetchSuccess,
  handleThumbnailFetchFailure,
  handleSendActivityFetchSuccess,
  handleSendActivityFetchFailure,
  deselectAllItems,
  selectItems,
  toggleSelectionForItem,
} from './actions';

const initialState = {
  thumbnails: {},
  sendActivity: {},
  selectedItems: {},
};

type WorkflowIndexAction =
  | ReturnType<typeof handleThumbnailFetchSuccess>
  | ReturnType<typeof handleThumbnailFetchFailure>
  | ReturnType<typeof handleSendActivityFetchSuccess>
  | ReturnType<typeof handleSendActivityFetchFailure>
  | ReturnType<typeof toggleSelectionForItem>
  | ReturnType<typeof selectItems>
  | ReturnType<typeof deselectAllItems>;

const createPlaceholderCacheEntries = (ids: number[]) =>
  ids.reduce((acc, id) => ({ ...acc, [id]: null }), {});

const toggleValueInSet = <T>(set: Set<T>, item: T) => {
  if (set.has(item)) {
    set.delete(item);
    return set;
  }
  return set.add(item);
};

export const workflowIndexReducer = (
  state: WorkflowIndexReduxState = initialState,
  action: WorkflowIndexAction,
) => {
  switch (action.type) {
    case REDUX_ACTION_TYPES.THUMBNAILS_FETCH_SUCCEEDED:
      return {
        ...state,
        thumbnails: {
          ...state.thumbnails,
          ...createPlaceholderCacheEntries(action.templateIds),
          ...action.thumbnails,
        },
      };
    case REDUX_ACTION_TYPES.THUMBNAILS_FETCH_FAILED:
      return {
        ...state,
        sendActivity: {
          ...state.sendActivity,
          ...createPlaceholderCacheEntries(action.templateIds),
        },
      };
    case REDUX_ACTION_TYPES.SEND_ACTIVITY_FETCH_SUCCEEDED:
      return {
        ...state,
        sendActivity: {
          ...state.sendActivity,
          ...createPlaceholderCacheEntries(action.workflowIds),
          ...action.sendActivity,
        },
      };
    case REDUX_ACTION_TYPES.SEND_ACTIVITY_FETCH_FAILED:
      return {
        ...state,
        sendActivity: {
          ...state.sendActivity,
          ...createPlaceholderCacheEntries(action.workflowIds),
        },
      };
    case REDUX_ACTION_TYPES.TOGGLE_SELECTION_FOR_ITEM:
      return {
        ...state,
        selectedItems: {
          ...state.selectedItems,
          [action.item.type]: toggleValueInSet(
            new Set(state.selectedItems[action.item.type]),
            action.item.id,
          ),
        },
      };
    case REDUX_ACTION_TYPES.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.items.reduce(
          (previousValue, item) => ({
            ...previousValue,
            [item.type]: new Set(previousValue[item.type]).add(item.id),
          }),
          state.selectedItems,
        ),
      };
    case REDUX_ACTION_TYPES.DESELECT_ALL_ITEMS:
      return {
        ...state,
        selectedItems: {},
      };
    default:
      return state;
  }
};
